import auth from '../../middlewares/auth';

export const nameRoutes = [
  {
    path: '/names',
    component: () =>
      import(
        /* webpackChunkName: "names" */ '../../views/inventory/names/Index'
      ),
    name: 'names',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-name-manage'],
    },
  },
  {
    path: '/names/:id',
    component: () =>
      import(
        /* webpackChunkName: "names" */ '../../views/inventory/names/Form'
      ),
    name: 'update-names',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-name-manage'],
    },
  },
  {
    path: '/create-names',
    component: () =>
      import(
        /* webpackChunkName: "names" */ '../../views/inventory/names/Form'
      ),
    name: 'create-names',
    meta: {
      middleware: [auth],
      requiredPermissions: ['inventory-name-manage'],
    },
  },
];
